import React, {useMemo, useState} from "react";
import { Box, Grid, Typography, Paper } from "@material-ui/core";
import styled from "styled-components/macro";
import { GenericSidePanel } from "../../../../components/SidePanel/GenericSidePanel.comp";
import MonthRangePicker from "../../../../components/DatePickers/MonthRangePicker.comp";
import BarChart from "../../../SchoolDashboard/Assessment/components/BarChart";
import LoaderWithBackDrop from "../../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {getChartData} from "../../../../utils/utils";

const years = ["All Years", "2022", "2023"];

const PanelBox = styled(Paper)`
    background: #223047;
    border-radius: 10px;
    min-height: 560px;
    width: 260px;
    max-width: 260px;
    padding: 24px 16px;
    color: #fff;
    position: relative;
`;

const StatCard = styled(Box)`
    background: #233049;
    border-radius: 14px;
    min-width: 180px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
`;

const ContentBox = styled(Box)`
    background: #f8fafc;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(10,20,40,0.04);
    padding: 32px;
    margin-left: 0;
    min-height: 540px;
    max-width: 900px;     // Limit max width!
    width: 100%;
    overflow-x: auto;
`;

const chartData = {
    labels: ['Junior', 'Senior'],
    datasets: [{
        label: 'Participants',
        data: [0, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000],
        backgroundColor: '#78A8DC',
        borderWidth: 0
    }]
};

function ParticipationSummaryTab({ data, loading, error }) {
    const [monthRange, setMonthRange] = useState([null, null]);
    const [minDate, maxDate] = [new Date(2022, 0, 1), new Date(2023, 11, 31)];

    const byMonthChart = useMemo(
        () => getChartData(data?.byMonth, "month", "participants", { monthFormat: true, labelText: "# of Participants" }),
        [data]
    );
    const byGradeLevelChart = useMemo(
        () => getChartData(data?.byGradeLevel, "grade", "participants", { labelText: "# of Participants" }),
        [data]
    );
    const byAgeChart = useMemo(
        () => getChartData(data?.byAge, "age", "participants", { labelText: "# of Participants", labelFormatter: (age) => `${age} Years Old` }),
        [data]
    );

    return (
        <Box px={2} py={3} width="100%">
            <Typography variant="h4" align="center" style={{ fontWeight: 700, marginBottom: 40 }}>
                School Participation Summary
            </Typography>
            <Box display="flex" flexDirection="row" justifyContent="center" width="95%" sx={{mx:"auto"}}>
                {/* Side Panel */}
                {/*<PanelBox elevation={0}>*/}
                {/*    <GenericSidePanel*/}
                {/*        data={[years]}*/}
                {/*        headers={["Select a Time Period"]}*/}
                {/*        visible={[true]}*/}
                {/*        colourize={[false]}*/}
                {/*        defaultCheckIndices={[0]}*/}
                {/*        footers={[MonthRangePicker]}*/}
                {/*        footersData={[{ minDate, maxDate, value: monthRange }]}*/}
                {/*        footersCallbacks={[{ onChangeDate: setMonthRange }]}*/}
                {/*    />*/}
                {/*</PanelBox>*/}
                {/* Main Content */}
                <Box flex={1} pl={4} style={{ minWidth: 0 }}>
                    {/*<ContentBox>*/}
                        {/* Top Stat Card and Placeholder Chart */}
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <StatCard>
                                    <Typography style={{ color: "#17e9ef", fontSize: 13, fontWeight: 600 }}>
                                        TOTAL PARTICIPATION
                                    </Typography>
                                    <Typography variant="h4" style={{ color: "#fff", fontWeight: 900, letterSpacing: 1 }}>
                                        {data ? data.total : "0"}
                                    </Typography>
                                </StatCard>
                            </Grid>
                            <Grid item xs>
                                <Box style={{ width: "100%", minHeight: 180, background: "#fff", borderRadius: 12, boxShadow: "0 1px 6px #0001", padding: 18 }}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 700, marginBottom: 8 }}>
                                        By Participation
                                    </Typography>
                                    <Box style={{ background: "#fff", borderRadius: 12, minHeight: 220, display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontWeight: 700 }}>
                                        <BarChart
                                            labels={byMonthChart.labels}
                                            datasets={byMonthChart.datasets}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                        {/* Bottom Section: Cards for other stats/charts */}
                        <Box mt={12}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Box style={{ background: "#fff", borderRadius: 12, minHeight: 220, display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontWeight: 700 }}>
                                        <BarChart
                                            labels={byGradeLevelChart.labels}
                                            datasets={byGradeLevelChart.datasets}
                                        />
                                    </Box>
                                    <Typography variant="subtitle2" align="center" style={{ fontWeight: 600, marginTop: 12 }}>By Grade Level</Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box style={{ background: "#fff", borderRadius: 12, minHeight: 220, display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontWeight: 700 }}>
                                        <BarChart
                                            labels={byAgeChart.labels}
                                            datasets={byAgeChart.datasets}
                                        />
                                    </Box>
                                    <Typography variant="subtitle2" align="center" style={{ fontWeight: 600, marginTop: 12 }}>By Age</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    {/*</ContentBox>*/}
                </Box>
            </Box>
            <LoaderWithBackDrop loading={loading} />
        </Box>
    );
}

export default ParticipationSummaryTab;